// Day 2 — 48 hours left.

import type { EmailData } from "../../types";
import { longDate } from "../../format";
import { b, esc, p } from "../../layouts/chrome";
import { NO_PAYMENT, pricedEmailHtml } from "../../layouts/priced";
import { brand } from "../brand";

export const subject = (_data: EmailData) => `48 hours left to renew with ${brand.name}`;

export const html = (data: EmailData) =>
  pricedEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    quotes: data.quotes ?? [],
    payment: data.payment ?? NO_PAYMENT,
    policyRef: data.policyRef,
    versionRef: data.versionRef,
    bodyHtml: p(
      `This is an urgent reminder from ${brand.name} — you have 48 hours left. Your insurance policy for ${b(`'${esc(data.companyName)}' will expire on ${longDate(data.renewalDate)}`)}. Your policy will ${b("not auto-renew")}: call now to avoid a break in cover.`,
    ),
  });
